import useStructuredData from '@swf/core/hooks/useStructuredData';
import type { StructuredData as StructuredDataType } from '@swf/core/providers/StructuredDataProvider';

interface Props {
  data: StructuredDataType;
}

const StructuredData: React.FC<Props> = ({ data }) => {
  const { addStructuredData } = useStructuredData();

  addStructuredData(data);

  return null;
};

export default StructuredData;
